export default __webpack_public_path__ + "static/media/eleanor-roosevelt.3e1a99dc.png";